export default __webpack_public_path__ + "static/pro@992_2x-bb5a09da0a26c6a1b3f02bb4e0d41d6d.png";